import { Box, Button, HStack, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { FiEdit2 } from 'react-icons/fi'
import { CHAMBER_LABELS } from './chamberFilter'
import { LegislatorResourceLinks } from './LegislatorResourceLinks'
import type { LegislatorDto } from '../../types/lobbyDay'

function Field({ label, value }: { label: string; value: string | null | undefined }) {
  return (
    <Box>
      <Text fontSize="xs" fontWeight="medium" color="fg.muted">{label}</Text>
      <Text fontSize="sm">{value?.trim() ? value : '—'}</Text>
    </Box>
  )
}

export function LegislatorReadOnlyView({ legislator, onEdit }: { legislator: LegislatorDto; onEdit: () => void }) {
  return (
    <VStack align="stretch" gap={4}>
      <HStack justify="space-between" align="start">
        <Text fontSize="lg" fontWeight="semibold">{legislator.fullName}</Text>
        <Button size="sm" variant="outline" onClick={onEdit}><FiEdit2 /> Edit information</Button>
      </HStack>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
        <Field label="Chamber" value={CHAMBER_LABELS[legislator.chamber]} />
        <Field label="District" value={legislator.district} />
        <Field label="State" value={legislator.state} />
        <Field label="Party" value={legislator.party} />
        <Field label="Office / room" value={legislator.officeRoom} />
        <Field label="Phone" value={legislator.phone} />
        <Field label="Email" value={legislator.email} />
      </SimpleGrid>
      {legislator.background?.trim() && (
        <Box>
          <Text fontSize="xs" fontWeight="medium" color="fg.muted" mb={1}>Background</Text>
          <Text fontSize="sm" whiteSpace="pre-wrap">{legislator.background}</Text>
        </Box>
      )}
      <LegislatorResourceLinks
        variant="inline"
        ballotpediaUrl={legislator.ballotpediaUrl}
        voteSmartUrl={legislator.voteSmartUrl}
        openSecretsUrl={legislator.openSecretsUrl}
        followTheMoneyUrl={legislator.followTheMoneyUrl}
      />
    </VStack>
  )
}
